module.exports = __webpack_public_path__ + "static/media/burger.3de3e629.svg";